var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contact_info || _vm.contact)?_c('div',{staticClass:"contact-content"},[(_vm.contact_info)?_c('div',[_vm._v(_vm._s(_vm.contact_info))]):_vm._e(),_vm._v(" "),(_vm.contact_value)?_c('img',{attrs:{"src":_vm.contact_value,"alt":""},on:{"click":_vm.showPic}}):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c12a9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/contact.vue
// module id = null
// module chunks = 